var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('verification-input-by-number',_vm._g(_vm._b({model:{value:(_vm.proxyValue),callback:function ($$v) {_vm.proxyValue=$$v},expression:"proxyValue"}},'verification-input-by-number',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }